import React, { CSSProperties, useEffect, useState } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import CumulativePerformanceTable from './CumulativePerformanceTable';
import CalendarPerformanceTable from './CalendarPerformanceTable';
import AnnualisedPerformanceTable from './AnnualisedPerformanceTable';
import DiscretePerformanceTable from './DiscretePerformanceTable';
import MaxDrawdownTable from './MaxDrawdownTable';
import Tabs from '@material-ui/core/Tabs';
import Tab from 'components/Base/Tabs/Tab';
import GlossaryLookup from 'components/Homepage/components/Glossary/GlossaryLookup';
import { compose } from 'ramda';
import Store from 'store/store';
import { MetaType } from 'store/modules/Meta/types';

const { connect, selectors } = Store;

interface PastPerformanceTableProps {
  existingOnly?: boolean;
  data: any;
  hideMaxDrawDown?: boolean;
  benchmarks: Array<MetaType>;
}

const useStyles = makeStyles({
  title: {
    fontSize: '1.1rem',
    fontWeight: 600,
    lineHeight: '1.3rem',
    whiteSpace: 'nowrap',
    marginTop: '1rem',
    marginBottom: '0.5rem'
  },
  '@global': {
    '.MuiTable-root': {
      // border: '1px solid rgba(224, 224, 224, 1)',
      borderRadius: '25px',
      borderCollapse: 'initial'
    }
  }
});

const PastPerformanceTable = ({
  existingOnly = false,
  data,
  hideMaxDrawDown = false,
  benchmarks
}: PastPerformanceTableProps) => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    setTableData({ ...data });
  }, [data]);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  const tabProps = (index: any) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
      style: {
        textTransform: 'none'
      } as CSSProperties
    };
  };

  const components = [
    { title: 'Cumulative', component: CumulativePerformanceTable },
    { title: 'Discrete', component: DiscretePerformanceTable },
    { title: 'Annualised', component: AnnualisedPerformanceTable },
    { title: 'Calendar', component: CalendarPerformanceTable },
    { title: 'Max Drawdown', component: MaxDrawdownTable }
  ] as any;

  const currentTitle = components[tab].title;
  const CurrentComponent = components[tab].component;

  return (
    <>
      <Tabs
        style={{ marginBottom: '2rem' }}
        value={tab}
        onChange={handleTabChange}
        TabIndicatorProps={{
          style: { display: 'none' }
        }}
      >
        <Tab label={components[0].title} {...tabProps(0)} />
        <Tab label={components[1].title} {...tabProps(1)} />
        <Tab label={components[2].title} {...tabProps(2)} />
        <Tab label={components[3].title} {...tabProps(3)} />
        {!hideMaxDrawDown && (
          <Tab label={components[4].title} {...tabProps(4)} />
        )}
      </Tabs>

      <Typography variant="h3" className={classes.title}>
        <GlossaryLookup term={`${currentTitle} Performance`} />
      </Typography>
      <CurrentComponent
        existingOnly={existingOnly}
        data={tableData}
        benchmarks={benchmarks}
      />
    </>
  );
};

export default compose(
  connect((state: any) => ({
    benchmarks: selectors.metaSelectors.benchmarks(state)
  }))
)(PastPerformanceTable);
